import React, { useEffect, useRef, useState } from "react";
import { TableWrapper } from "../../Components/styledConstant";
import LocalLoader from "../../Components/Loader/LocalLoader";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import { AlertWrapper } from "../../assets/styles/AlerWrapper";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import companylogo from "../../assets/images/companylogo.png";
import DatePicker from "react-datepicker";
import Pagination from "../../Components/Pagination/Pagination";
import {
  getDateFromDateObj,
  isAlphabet,
  isEmpty,
  isNumber,
  pdfData,
} from "../../utils/common";
import animationData1 from "../../assets/lotties/question.json";
import { cdmAssignedList,  updateMapedCardStatus } from "../../utils/api";
import ModalData from "../../Components/ModalData/ModalData";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";

const CdmMaped = () => {
  const [downloadLoader, setDownloadLoader] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [fromDate, setStartDate] = useState("");
  const [toDate, setEndDate] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [totalElements, setTotalElements] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [cardNumber, setCardNumber] = useState("");
  const [mappedId, setMappedId] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [unassignedDevice, setUnassignedDevice] = useState("");
  const [assignDevice, setAssignDevice] = useState();
  const [pdfData_, setPdfData] = useState([]);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState();
  const link = useRef();

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };



    const clearRef = useRef(null);
  const clearDate = (callback) => {
    if (clearRef.current) return;
    clearRef.current = callback;
  };

  const constChangeDate = (startDate, endDate) => {
    if (endDate) {
      setEndDate(endDate);
      setStartDate(startDate);
    }
  };

  const onClearDate = () => {
    setEndDate("");
    setStartDate("");
  };




  const handleAssignDevice = async (key,page = null,cardStatus = null) => {

    let _fromDate = "";
  let _toDate = "";

  if (fromDate !== "" && toDate !== "") {
    _fromDate = getDateFromDateObj(fromDate, "YYYY-MM-DD");
    _toDate = getDateFromDateObj(toDate, "YYYY-MM-DD");
  }

    let param = {
      page: currPage,
      size: pageSize,
      cardNumber: cardNumber,
      userId: mappedId,
      fromDate: _fromDate,
      toDate: _toDate,
    
    };
  

    if(page !== null){
        param.page = page;
        setCurrPage(page)
       }
    setStatus(cardStatus);
    if (!isEmpty(cardStatus) && key !== "refresh") {
      param.status = cardStatus;
    }
    
   
    if(key === "refresh"){
      param = {
        page: 0,
        cardNumber: "",
        fromDate: "",
        toDate: "",
      };
      dataRefresh();
    }
 
    if(key === "CSV"){
      setDownloadLoader("CSV");
      param.size = totalElements;
    }else if(key === "PDF"){
      setDownloadLoader("PDF");
      param.size = totalElements;
    }else{
      setLoading(true);
    }
  

    cdmAssignedList(param).then((resp) => {
      setLoading(false);
      setDownloadLoader("");
      if (resp?.data.success) {
        if (key === "CSV") {
          setPdfData(resp?.data?.data?.content);
          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          userlistPdfData(resp?.data?.data?.content);
        } else {
          setAssignDevice(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
        }
      }
    });
  };
  useEffect(() => {
    handleAssignDevice("",0);
  }, []);

  const dataRefresh = () => {
    setStartDate("");
    setEndDate("");
    setCurrPage(0);
    setStatus(null);
    setMappedId("");
    setCardNumber("");
       if (clearRef.current) {
      clearRef.current();
    }
  };


  //delete Device

  const deleteDevice = (userId) => {
    setUnassignedDevice(userId);
  };

  const unAssignDevice = () => {
    const param = {
        mappedId:unassignedDevice
    }

    updateMapedCardStatus(param).then((resp) => {
      if (resp?.data?.success) {
        setMessage({
          msg: "Device status changed successfully.",
          type: "success",
        });
        handleAssignDevice();
        setTimeout(() => {
          setUnassignedDevice({});
          setMessage({});
        }, 2000);
       
      } else {
        let msg = "";
        if (resp?.data?.errorCodeList.length > 0) {
          setMessage({ msg: msg, type: "error" });
        } else {
          setMessage({ msg: msg, type: "error" });
        }
      }
    });
  };


  const userlistPdfData = (data = []) => {
  
    const tableHeader = [
      {
        cardNumber: "Card Number",
        userFullName: "User Name",
        userNumber: "Mobile Number",
        mappedId: "Mapped Id",
        createdDate: "Created Date",
        status: "Status"
       
      },
    ];

    pdfData(data, tableHeader, 'CDM-mapped-InventoryList.pdf', );
  };


  return (
    <div>
      {message && (
        <AlertWrapper className="success globle">
          <span className="close" onClick={() => setMessage("")}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="" style={{ padding: "30px" }}>
        <div className="userlist_head">
          <div className="userlist_heading">
            <div className="userlist_left">
              <label>Assigned CDM Card List</label>
            </div>
            <div className="userlist_right">
              {downloadLoader !== "PDF" ? (
                <button
                  className="pdf"
                  onClick={(e) => handleAssignDevice("PDF")}
                >
                  PDF
                </button>
              ) : (
                <button className="pdf">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}

              {downloadLoader !== "CSV" ? (
                <button
                  className="xls"
                  onClick={(e) => handleAssignDevice( "CSV")}
                >
                  CSV
                </button>
              ) : (
                <button className="xls">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}
              <CSVLink
                ref={link}
                data={pdfData_}
                filename="CDM-mapped-InventoryList.csv"
              ></CSVLink>
            </div>
            <div className="userlist_filter">
              <button
                className="filter fs-16"
                onClick={(e) =>
                  showfilter === "active"
                    ? setShowFilter("")
                    : setShowFilter("active")
                }
              >
                <i className="fa-solid fa-filter"></i>
              </button>
            </div>
          </div>
        </div>
        <FilterWrapper
          style={{ height: "auto" }}
          className={`display_data ${showfilter}`}
        >
          <div className="filterBox">
            <div style={{width:"100%"}}>
              <div className="flex align-items gap-15">
                <div>
                  <input
                    type="text"
                    name="cardNumber"
                    placeholder="Enter device id"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                    maxLength={16}
                  />
                </div>
                <div>
                  <input
                    type="text"
                    name="MappedId"
                    placeholder="Mapped Id"
                    value={mappedId}
                    onChange={(e) => setMappedId(e.target.value)}
                   
                  />
                </div>
                <div className="input-field">
                  <select
                  onChange={(e) =>   handleAssignDevice("",0,e.target.value)}
                    value={status}
                    className="input_select_field"
                  >
                    <option value={null} selected>
                      Status
                    </option>
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">InActive</option>
                    <option value="MAPPED">Mapped</option>
                  </select>
                </div>
                {/* <div className="input-field">
                  <div className="flex">
                    <DatePicker
                      showIcon
                      className="date-picker2 date_type"
                      placeholderText="From Date"
                      selected={fromDate}
                      selectsStart
                      startDate={fromDate}
                      endDate={toDate}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => setStartDate(date)}
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="input-field">
                  <div className="flex">
                    <DatePicker
                      showIcon
                      className="date-picker2 date_type"
                      placeholderText="To Date"
                      selected={toDate}
                      selectsEnd
                      startDate={fromDate}
                      endDate={toDate}
                      minDate={fromDate}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => setEndDate(date)}
                      maxDate={new Date()}
                    />
                  </div>
                </div> */}
                  <DateRangePicker
                    applyDate={constChangeDate}
                    defaultDate={null}
                    onClear={onClearDate}
                    clearDate={clearDate}
                  />
                <div className="button">
                  <button
                    className="userlist_btn"
                    onClick={(e) => handleAssignDevice("search")}
                  >
                    Search
                  </button>
                </div>
                <div className="button">
                  <button
                    className="refresh-btn"
                    onClick={(e) => handleAssignDevice("refresh")}
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>

        {
          <div className="table-loader">
            {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Card Number</th>
                    <th>User Name</th>
                    <th>User Mobile</th>
                    <th>Mapped Id</th>
                    <th>Created Date</th>
                    <th>Status</th>
                     <th>Action</th>  
                  </tr>
                </thead>
                <tbody>
                  {assignDevice?.map((item, index) => {
                    const dateTimeString = item?.createdDate;
                    let [date, time] = dateTimeString.split("T");
                    let newTime = time.slice(0, 8);
                    return (
                      <tr key={index}>
                        <td className="td-none">
                          <span className="card-th">Sr No</span>
                          <span>{index + 1}</span>
                        </td>

                        <td className="pointer">
                          <span className="card-th">Card Number</span>
                          <span
                            className="tooltip"
                            data-tooltip={
                              item?.cardNumber || "Diwakar Upadhyay"
                            }
                          >
                            {item?.cardNumber || "-"}
                          </span>
                        </td>
                        <td>
                          <span className="card-th">User Name</span>
                          <span>{item?.userFullName || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">User Mobile</span>
                          <span>{item?.userNumber || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Mapped Id</span>
                          <span>{item?.mappedId || "-"}</span>
                        </td>

                        <td>
                          <span className="card-th">Created Date</span>
                          <span>{date + " " + newTime}</span>
                          {/* <span>{item?.createDate}</span> */}
                        </td>
                        <td>
                          <span className="card-th">Status</span>
                          <span>
                            <div
                              className={`${
                                item.status == "ACTIVE"
                                  ? "active_status"
                                  : "inactive_status"
                              }`}
                            >
                              {item?.status || "-"}
                            </div>
                          </span>
                        </td>
                        
                         <td className="user_action_btn">
                          <span className="card-th">Actions</span>
                          <span className="center flex gap-10">
                            <div
                              className={`custom-toggle toggle_button ${
                                item.status === "ACTIVE" ? "active" : ""
                              }`}
                              onClick={() =>deleteDevice(item.mappedId)}
                            >
                              <div className="slider"></div>
                            </div>

                           
                          </span>
                        </td>  
                      </tr>
                    );
                  })}

                  {!loading && assignDevice && assignDevice.length < 1 && (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ textAlign: "center", color: "red" }}
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </TableWrapper>
          </div>
        }
          <div style={loading ? { opacity: "0" } : { opacity: "1" }}>
        {totalPages > 1 && (
          <Pagination
            items={assignDevice}
            itemsPerPage={pageSize}
            setitemsPerPage={setPageSize}
            currentPage={currPage}
            setcurrentPage={(currPage) =>  handleAssignDevice("pagination",currPage)}
            totalPages={totalPages}
          />
        )}
      </div>
      </div>
    
      {!isEmpty(unassignedDevice) && (
        <ModalData
          onClickCancel={() => setUnassignedDevice(null)}
          onClickConfirm={() => unAssignDevice()}
          lottieOptions={defaultOptions1}
          heading1="You want to change device status?"
        />
      )}
    </div>
  );
};

export default CdmMaped;
